export default {
  showNotification: state => state.notificationState.show,
  getNotificationDuration: state => state.notificationState.duration,
  getNotificationMessage: state => state.notificationState.message,
  getNotificationContent: state => state.notificationState.content,
  getNotificationType: state => state.notificationState.type
};
